/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Contract Management API
 * API for Contract management UI.
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ContractDetails,
  ContractId,
  ContractPage,
  GetContractsParams,
  PolicyNumber
} from '../../models';




  export const getContracts = (axiosInstance: AxiosInstance = axios.default) => {
/**
 * Gets contracts by search text or VIN, up to the required limit, with the total number of matching contracts.
 * @summary Gets contracts by search criteria and required limit
 */
const getContracts = (
    params: GetContractsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContractPage>> => {
    return axiosInstance.get(
      `/contracts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Gets contract details by contract id
 */
const getContractById = (
    contractId: ContractId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContractDetails>> => {
    return axiosInstance.get(
      `/contracts/${contractId}`,options
    );
  }
/**
 * Calls the enterprise Policy Document service and streams back the policy PDF for the given policy number. Not cached client-side; the BFF caches the fetched document briefly.
 * @summary Downloads the policy document for a policy number
 */
const downloadPolicyDocument = (
    policyNumber: PolicyNumber, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axiosInstance.get(
      `/contracts/${policyNumber}/policy-document`,{
        responseType: 'blob',
    ...options,}
    );
  }
return {getContracts,getContractById,downloadPolicyDocument}};
export type GetContractsResult = AxiosResponse<ContractPage>
export type GetContractByIdResult = AxiosResponse<ContractDetails>
export type DownloadPolicyDocumentResult = AxiosResponse<Blob>
